// Shared layout for the tiny smooth/lumpy takeoff tooltip sketches.
// Capability scale: 0.01× at the bottom of the plot → 100× at the top, so
// Human Level (1×) sits mid-plot on the log scale with room below it.
// Flip CAPABILITY_SCALE below to switch between linear and log spacing —
// everything (gridlines, labels, curve paths) derives from capabilityY /
// capabilityAtY, so the toggle propagates automatically.
// Human Level gridline sits at 1×; on the linear scale its label is offset
// below to clear 10× (on the log scale 10× sits mid-plot, so no offset).

export const CAPABILITY_SCALE: 'linear' | 'log' = 'log';

export const VX = -20;
export const VW = 312;
// Trimmed to just clear PLOT_B (+ a hair for stroke) — extra viewBox height
// below scales into visible bottom padding wherever the sketch renders.
export const VH = 102;
export const PLOT_L = 8;
export const PLOT_R = 292;
export const PLOT_T = 6;
export const PLOT_B = 100

const CAP_MIN = 0.01;
const CAP_MAX = 100;

export const LABEL_FS = 8;
export const LABEL_LH = 10;

export function capabilityY(cap: number): number {
  const frac = CAPABILITY_SCALE === 'log'
    ? Math.log(cap / CAP_MIN) / Math.log(CAP_MAX / CAP_MIN)
    : (cap - CAP_MIN) / (CAP_MAX - CAP_MIN);
  return PLOT_B - frac * (PLOT_B - PLOT_T);
}

export function capabilityAtY(y: number): number {
  const frac = (PLOT_B - y) / (PLOT_B - PLOT_T);
  return CAPABILITY_SCALE === 'log'
    ? CAP_MIN * Math.pow(CAP_MAX / CAP_MIN, frac)
    : CAP_MIN + frac * (CAP_MAX - CAP_MIN);
}

export type TakeoffLevel = {
  lines: readonly string[];
  lineY: number;
  labelY?: number;
};

export const LEVELS: readonly TakeoffLevel[] = [
  { lines: ['100×'], lineY: capabilityY(100) },
  { lines: ['10×'], lineY: capabilityY(10) },
  {
    lines: ['Human', 'Level'],
    lineY: capabilityY(1),
    // Linear scale squeezes 10× down near 1×, so drop the label to clear it.
    labelY: CAPABILITY_SCALE === 'log' ? capabilityY(1) + 6 : undefined,
  },
];
